module.exports = __webpack_public_path__ + "img/f8179b9d389f83f62f9746db5eaee924.png";